import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 4);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="articles-title">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-3">
          <div>
            <h2 id="articles-title" className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
              精选技术文章
            </h2>
            <p className="text-sm text-foreground-600">喷水系统专业知识与实用指南</p>
          </div>
          <Link
            to="/category"
            className="whitespace-nowrap cursor-pointer text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors flex items-center gap-1"
          >
            查看全部文章 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-background-50/90 text-xs text-primary-600 font-medium">
                    {article.category === 'agricultural' ? '农业灌溉' : article.category === 'landscape' ? '景观喷水' : '工业冷却'}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}